// extracted by mini-css-extract-plugin
module.exports = {"projectSection":"ProjectSection_projectSection__3XdI2"};